import { Action, createReducer, on } from '@ngrx/store';
import { DataFilterInstanceState } from '../../../models';
import { DataFilterAction } from '../../actions';
import { FilterInstanceHelper, SearchHelper } from '../../utils';
import { dataFilterInstanceReducerFactory } from './data-filter-instance.reducer';

export interface DataFilterState {
  [instanceId: string]: DataFilterInstanceState;
}

const dataFilterActionTypes = new Set<string>(
  Object.values(DataFilterAction)
    .map((action) => action.type)
    .filter((actionType) => actionType)
);

const initialState: DataFilterState = {};

const dataFilterInstanceReducer = dataFilterInstanceReducerFactory(FilterInstanceHelper.Instance, SearchHelper.Instance);

const filterReducer = createReducer(
  initialState,
  on(DataFilterAction.init, (state, action) => {
    return {
      ...state,
      [action.instanceId]: {
        ...dataFilterInstanceReducer(undefined, action),
        queryParamsDisabled: action.queryParamsDisabled
      },
    };
  }),
  on(DataFilterAction.destroy, (state, action) => {
    const newState = { ...state };

    delete newState[action.instanceId];
    return newState;
  })
);

export function dataFilterReducer(state = initialState, action: Action): DataFilterState {
  let stateToReturn = filterReducer(state, action);

  if (dataFilterActionTypes.has(action.type)) {
    const instanceId = (action as any).instanceId;

    if (instanceId in stateToReturn) {
      const currentInstanceState = stateToReturn[instanceId];
      const newInstanceState = dataFilterInstanceReducer(stateToReturn[instanceId], action);

      if (currentInstanceState !== newInstanceState) {
        stateToReturn = {
          ...stateToReturn,
          [instanceId]: {
            ...currentInstanceState,
            ...newInstanceState
          },
        };
      }
    }
  }

  return stateToReturn;
}
